import classNames from 'classnames'
import { motion } from 'framer-motion'
import { Text } from '../Text'
import { useTabsContext } from './Tabs'
import type { TabProps } from './types'

export const Tab: React.FC<React.PropsWithChildren<TabProps>> = ({
  index,
  children,
}) => {
  const { setActiveTab, activeTab, id } = useTabsContext()

  const isActive = activeTab === index
  const baseId = `${id}-tab[${index}]`

  return (
    <button
      aria-controls={`${baseId}-panel`}
      aria-selected={isActive}
      id={`${baseId}-button`}
      className={classNames('py-4 relative w-full flex justify-center')}
      onClick={() => setActiveTab(index)}
      role="tab"
    >
      <Text variant={isActive ? 'title-six' : 'body-md'} className="leading-md">
        {children}
      </Text>

      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-[#E7E7E7] " />

      {isActive && (
        <motion.div
          layoutId={`${id}-tab-underline`}
          className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#3D3D3D] z-10"
          transition={{
            type: 'tween',
            duration: 0.3,
            ease: 'easeOut',
          }}
          initial={false}
          style={{
            transform: 'translateZ(0)',
            willChange: 'transform',
          }}
        />
      )}
    </button>
  )
}
